import React, {useState, useEffect} from 'react';
import axios from "axios"
import DashboardHeader from '../../components/DashboardHeader';

// import {calculateRange, sliceData} from '../../utils/table-pagination';

import '../styles.css';
import DoneIcon from '../../assets/icons/done.svg';
import CancelIcon from '../../assets/icons/cancel.svg';

function GymMembers () {

    const [ gymData, setGymData ] = useState([])

    const setStatus0 = (order) => {
        axios.put('https://buckinghammall-gym-api.eddyspace.com/api/users/' + order.user_id + "/update-status", 
        {
            is_active: 0,
        }
        )
        .then(response => {
            console.log('Response:', response.data);
            alert('User Updated')
            setTimeout(() => {
                window.location.reload()
            }, 100)
        })
        .catch(error => {
            console.error('Error:', error);
        });
    }

    const setStatus1 = (order) => {
        axios.put('https://buckinghammall-gym-api.eddyspace.com/api/users/' + order.user_id + "/update-status", 
        {
            is_active: 1,
        }
        )
        .then(response => {
            console.log('Response:', response.data);
            alert('User Updated')
            setTimeout(() => {
                window.location.reload()
            }, 100)
        })
        .catch(error => {
            console.error('Error:', error);
        });
    }

    const [ cardID, setCardID ] = useState("")
    const [ userID, setUserID ] = useState("")

    const updateCardID = (order) => {
        axios.put('https://buckinghammall-gym-api.eddyspace.com/api/users/' + userID + "/update-cardID", 
        {
            cardID: cardID,
        }
        )
        .then(response => {
            console.log('Response:', response.data);
            alert('User Updated')
            setTimeout(() => {
                window.location.reload()
            }, 100)
        })
        .catch(error => {
            console.error('Error:', error);
        });
    }


    const [search, setSearch] = useState('');
    const [orders, setOrders] = useState(gymData);
    // const [page, setPage] = useState(1);
    // const [pagination, setPagination] = useState([]);

    useEffect(() => {
        axios.get('https://buckinghammall-gym-api.eddyspace.com/api/users')
          .then(response => {
            // Filter out items with 'subscription_type' equal to 'daily'
            const dataWithoutDaily = response.data.filter(item => (item.subscription_type !== 'daily') && (item.is_active !== '0'));
      
            // Slice 'updated_at' to include only the date part (e.g., "2023-09-17")
            const dataWithDateOnly = dataWithoutDaily.map(item => {
              return {
                ...item,
                updated_at: item.updated_at.slice(0, 10),
              };
            });
      
            // Sort orders by 'updated_at' in ascending order
            const sortedOrders = dataWithDateOnly.sort((a, b) => {
              const dateA = new Date(a.updated_at);
              const dateB = new Date(b.updated_at);
              return dateA - dateB;
            });
      
            console.log('Response:', sortedOrders);
      
            // Calculate pagination, slice data, and set gymData
            // const pagination = calculateRange(sortedOrders, 5);
            // const orders = sliceData(sortedOrders, page, 5);
            // setPagination(pagination);
            setOrders(sortedOrders);
            setGymData(sortedOrders);
          })
          .catch(error => {
            console.error('Error:', error);
          });
      }, []);
      
      
    

    // Search
    const __handleSearch = (event) => {
        setSearch(event.target.value);
        if (event.target.value !== '') {
            let search_results = orders.filter((item) =>
                item.first_name.toLowerCase().includes(search.toLowerCase()) ||
                item.last_name.toLowerCase().includes(search.toLowerCase()) ||
                item.email.toLowerCase().includes(search.toLowerCase()) ||
                item.subscription_type.toLowerCase().includes(search.toLowerCase())
            );
            setOrders(search_results);
        }
        else {
            __handleChangePage(1);
        }
    };

    // Change Page 
    const __handleChangePage = (new_page) => {
        // setPage(new_page);
        setOrders(gymData);
    }

    return(
        <div className='dashboard-content'>
            <DashboardHeader
                btnText="New Order" />

            <div className='dashboard-content-container'>
                <div className='dashboard-content-header'>
                    <h2>Gym Membership List</h2>
                    <div className='dashboard-content-search'>
                        <input
                            type='text'
                            value={search}
                            placeholder='Search..'
                            className='dashboard-content-input'
                            onChange={e => __handleSearch(e)} />
                    </div>
                </div>

                <table>
                    <thead>
                        <th>MEMBERSHIP</th>
                        <th>CARD ID</th>
                        <th>DATE</th>
                        <th>EXPIRATION</th>
                        <th>COSTUMER</th>
                        <th>ADDRESS</th>
                        <th>EMAIL</th>
                        <th>PHONE</th>
                        <th>SUBSCRIPTION</th>
                        {/* <th>PRICE</th> */}
                        <th>TX REFERENCE</th>
                        <th>STATUS</th>
                        <th>SET STATUS</th>
                    </thead>

                    {orders.length !== 0 ?
                        <tbody>
                            {orders.map((order, index) => (
                                <tr key={index}>
                                    <td><span>{order.user_id}</span></td>
                                    <td><span>{order.cardID}</span></td>
                                    <td><span>{order.updated_at}</span></td>
                                    <td><span>{order.expiration_date}</span></td>
                                    <td>
                                        <div>
                                            {/* <img 
                                                src={order.avatar}
                                                className='dashboard-content-avatar'
                                                alt={order.first_name + ' ' +order.last_name} /> */}
                                            <span>{order.first_name} {order.last_name}</span>
                                        </div>
                                    </td>
                                    <td><span>{order.address}</span></td>
                                    <td><span>{order.email}</span></td>
                                    <td><span>{order.phone_number}</span></td>
                                    {/* <td><span>{order.productID}</span></td>*/}
                                    <td><span>{order.subscription_type}</span></td> 
                                    {/* <td><span>                                            
                                            {order.subscription_type == 'monthly' ? 
                                                "₦25,000"
                                            : order.subscription_type == 'quarterly' ?
                                                "₦55,000"
                                            : order.subscription_type == 'annually' ?
                                                "₦160,000"
                                            : null}</span>
                                    </td> */}
                                    <td><span>{order.tx_reference}</span></td>
                                    <td>
                                        <div>
                                            {order.is_active == '1' ? 
                                                <img
                                                    src={DoneIcon}
                                                    alt='collected-icon'
                                                    className='dashboard-content-icon' />
                                            : order.is_active == '0' ?
                                                <img
                                                    src={CancelIcon}
                                                    alt='canceled-icon'
                                                    className='dashboard-content-icon' />
                                            : null}
                                            <span>{order.is_active == "1" ? "Active" : "Inactive"}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                                <img
                                                    src={DoneIcon}
                                                    style={{"cursor": "pointer"}}
                                                    onClick={() => setStatus1(order)}
                                                    alt='completed'
                                                    className='dashboard-content-icon' />
                                                <img
                                                    src={CancelIcon}
                                                    style={{"cursor": "pointer"}}
                                                    onClick={() => setStatus0(order)}
                                                    alt='canceled-icon'
                                                    className='dashboard-content-icon' />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    : null}
                </table>

                {orders.length !== 0 ?
                    <div className='dashboard-content-footer'>
                        {/* {pagination.map((item, index) => (
                            <span 
                                key={index} 
                                className={item === page ? 'active-pagination' : 'pagination'}
                                onClick={() => __handleChangePage(item)}>
                                    {item}
                            </span>
                        ))} */}
                    </div>
                : 
                    <div className='dashboard-content-footer'>
                        <span className='empty-table'>No data</span>
                    </div>
                }
            </div>
            <div style={{"width": "202px", "marginLeft": "445px"}}>
                <input 
                    className='dashboard-content-input'
                    placeholder='Enter Member ID' 
                    value={userID} 
                    onChange={e => setUserID(e.target.value)}
                />
                <input 
                    className='dashboard-content-input'
                    placeholder='Enter Card ID' 
                    value={cardID} 
                    onChange={e => setCardID(e.target.value)}
                />
                <button style={{"width": "100%"}} className='dashbord-header-btn' onClick={updateCardID}>Set</button>
            </div>

        </div>
    )
}

export default GymMembers;